import React, { Component } from 'react';
import './index.css';
import { Button, Radio, Input, Table } from 'antd';
import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { RootState } from '../../../../core/reducers';
import NewMerchant from './newMerchant'
import moment from 'moment'
import { 
    actionCreateStore,
    actionUpdateStore,
    actionGetStoreList,
    actionGetStoreListBySearch,
    actionOperateStoreFail,
} from '../../../../core/actions/scanner/store';

interface StateProps {
    orgInfo: any
    isSearch: boolean
    storeList: any
    storeListBySearch: any[]
    isSuccess: boolean,
    failData: string
}

interface DispatchProps {
    createStore(data) : void
    updateStore(odata, ndata): void
    getStoreList(): void
    getStoreListBySearch(data, key): void
    clearErrorData(): void
}

const { Search } = Input;

class Index extends Component<StateProps & DispatchProps> {
    
    Columns;
    constructor(props) {
        super(props);
        this.Columns = [
            {
                title: '商户ID',
                dataIndex: 'id',
                key: 'id'
            }, 
            {
                title: '商户名称',
                dataIndex: 'name',
                key: 'name'
            }, 
            {
                title: '联系方式',
                dataIndex: 'mobileNumber',
                key: 'mobileNumber',
            }, 
            {
                title: '账号状态',
                dataIndex: 'status',
                key: 'status'
            },
            {
                title: '开始时间',
                dataIndex: 'startTimestamp',
                key: 'startTimestamp',
                render: (text) => {
                    let time = moment(+text).format('YYYY-MM-DD HH:mm:ss');
                    return <span>{time}</span>
                }
            },
            {
                title: '截止日期',
                dataIndex: 'endTimestamp',
                key: 'endTimestamp',
                render: (text) => {
                    let time = moment(+text).format('YYYY-MM-DD HH:mm:ss');
                    return <span>{time}</span>
                }
            },
            {
                title: '操作',
                render : (record) => {
                    return (
                        <div>
                            <a onClick={() => this.onEdit(record)}>编辑</a>
                    </div>
                    )
                }
            }
        ];
    }

    static getDerivedStateFromProps (props, state) {
        if(props.failData) {
            return {
                confirmLoading: false,
            }       
        }
        else if(props.isSuccess) {
            return {
                confirmLoading: false,
                visible: false,
                data: {}
            }
        }
        return null;
    }

    onEdit = (record) => {
        console.log(record)
        let key = this.state.listKey;
        let startTimeFeet = 0;
        let endTimeFeet = 0;
        let startTimeScan = 0;
        let endTimeScan = 0;
        let timesKey: string[] = [];
        if(key === 'scan') {
            startTimeScan = record.startTimestamp;
            endTimeScan = record.endTimestamp;
            timesKey.push('SennoScan')
            let times = record.times;
            if(times.startTimestamp && times.endTimestamp ) {
                timesKey.push('SennoFeet');
                startTimeFeet = times.startTimestamp;
                endTimeFeet = times.endTimestamp;
            }
        }
        if(key === 'feet') {
            startTimeFeet = record.startTimestamp;
            endTimeFeet = record.endTimestamp;
            timesKey.push('SennoFeet')
            let times = record.times;
            if(times.startTimestamp && times.endTimestamp ) {
                timesKey.push('SennoScan');
                startTimeScan = times.startTimestamp;
                endTimeScan = times.endTimestamp;
            }
        }
        this.setState({
            data: {
                ...record,
                timesKey,
                startTimeFeet,
                endTimeFeet,
                startTimeScan,
                endTimeScan,
            },
            visible: true
        })
    }

    componentDidMount () {
        this.props.getStoreList();
    }

    onChangeRaido = (e) => {
        console.log(`radio checked: ${e.target.value}`)
        this.setState({
            listKey: e.target.value
        })
    }

    onSearch = (value) => {
        console.log(value)
        let key = this.state.listKey;
        this.props.getStoreListBySearch(value, key);
    }

    state = {
        visible: false,
        confirmLoading: false,
        listKey: 'scan',
        data: {} as any
    }

    showNewModal = () => {
        this.setState({
            visible: true,
            data: {}
        })
    }

    formatData = (values) => {
        let feetTime = values.sennoFeetTime;
        let startTimeFeet = 0;
        let endTimeFeet = 0;
        if(feetTime.length) {
            startTimeFeet = moment(feetTime[0]).unix() * 1000;
            endTimeFeet = moment(feetTime[1]).unix() * 1000
        }
        let scanTime = values.sennoScanTime;
        let startTimeScan = 0;
        let endTimeScan = 0;
        if(scanTime.length) {
            startTimeScan = moment(scanTime[0]).unix() * 1000;
            endTimeScan = moment(scanTime[1]).unix() * 1000
        }
        return {
            name: values.name,
            mobileNumber: values.mobileNumber,
            startTimeScan,
            endTimeScan,
            startTimeFeet,
            endTimeFeet,
        }
    }

    onCreate = (values) => {
        let sdata = this.formatData(values);
        console.log(sdata)
        let data = this.state.data;
       if(data && data.id) {
           this.props.updateStore(data, sdata);
       }
       else {
            this.props.createStore(sdata);
       }
    }

    onCancel = () => {
        this.setState({
            data: {},
            visible: false,
            confirmLoading: false,
        })
        this.props.clearErrorData();
    }

    render () {

        let store = this.props.storeList || {};
        let listKey = this.state.listKey;
        let data = store[`${listKey}`] || {};
        let list = data.list || [];
        let isSearch = this.props.isSearch;
        if(isSearch) {
            list = this.props.storeListBySearch || [];
        }

        let orgInfo = this.props.orgInfo || {};
        let disbaleTime = {
            start: +(orgInfo.startTimestamp || 0),
            end: +(orgInfo.endTimestamp || 0),
        }

        return (
            <div className="merchant model">
                <ul className="merchant-head">
                    <li>
                        <p>帐户总数</p>
                        <p>{data.allTotal}</p>
                    </li>
                    <li>
                        <p>生效帐户</p>
                        <p>{data.validTotal}</p>
                    </li>
                    <li>
                        <p>失效商户</p>
                        <p>{data.invalidTotal}</p>
                    </li>
                </ul>
                <div className="merchant-table-title">
                    <h3>商户列表</h3>
                    <div>
                        <Radio.Group onChange={this.onChangeRaido} defaultValue={this.state.listKey} >
                            {/* <Radio.Button value="scan">SennoScan</Radio.Button>
                            <Radio.Button value="feet">SennoFeet</Radio.Button> */}
                            <Radio.Button value="scan">SennoFeet</Radio.Button>
                            <Radio.Button value="feet">SennoScan</Radio.Button>
                        </Radio.Group>
                        <Search 
                            placeholder="输入商户名称或手机号搜索" 
                            allowClear
                            onSearch={this.onSearch}  
                            style={{width: 272}} 
                            className="margin-left-16"
                            />
                    </div>
                </div>
                <Button 
                    type="dashed" 
                    style={{width: '100%', marginBottom: '30px'}}
                    onClick={() => this.showNewModal()}
                    >+ 创建商户</Button>
                <Table 
                    rowKey={(record) => record.id}
                    dataSource={list} 
                    columns={this.Columns}
                    pagination={{
                        showSizeChanger: true,
                        defaultCurrent: 1,
                        total: list.length,
                        showTotal: total => `总 ${total} 条`
                    }}
                    />
                <NewMerchant 
                    disableTime={disbaleTime}
                    data={this.state.data}
                    visible={this.state.visible}
                    confirmLoading={this.state.confirmLoading}
                    onCreate={this.onCreate}
                    onCancel={this.onCancel}
                    failData={this.props.failData}
                    />
            </div>
        )
    }
}

function mapStateToProps(state: RootState): StateProps {
    return {
        storeList: state.store.storeList,
        storeListBySearch: state.store.storeListBySearch,
        isSearch: state.store.isSearch,
        failData: state.store.failData,
        isSuccess: state.store.isSuccess,
        orgInfo: state.user.orgInfo,
    }
}

function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): DispatchProps {
    return {
        createStore: (data) => {
            dispatch(actionCreateStore(data))
        },
        getStoreList: () => {
            dispatch(actionGetStoreList())
        },
        getStoreListBySearch: (data, key) => {
            dispatch(actionGetStoreListBySearch(data, key))
        },
        updateStore: (odata, ndata) => {
            dispatch(actionUpdateStore(odata, ndata))
        },
        clearErrorData: () => {
            dispatch(actionOperateStoreFail({
                data: ''
            }))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Index)